import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchTokenFile } from "../helpers/fetch";
import { types } from "../types/types";
import { t } from "i18next";
import { startLogout } from "./authActions";
import { debugLogActions } from "../helpers/debugHelper";
import { resolveImportStageFromState } from "../helpers/importStageHelper";
import { downloadImportExampleFile, downloadImportResultFile } from "../helpers/importExampleDownloadHelper";

export const startDownloadExperienceData = (bagRowProcess) => {
  return async (dispatch, getState) => {
    await downloadImportResultFile({
      parentRoute: `${const_routes.ROUTE_EXPERIENCE_FILE_DATA}`,
      endpoint: "downloadExperience",
      fullFilename: "3333_ExperienciasAdaptaciones.xlsx",
      preFilename: "3333_ExperienciasAdaptaciones_pre.xlsx",
      termFilename: "3333_ExperienciasAdaptaciones_term.xlsx",
      bagRowProcess,
      getState
    });
  };
};

export const startDownloadExperienceDataExample = () => {
  return async (dispatch, getState) => {
    await downloadImportExampleFile({
      parentRoute: `${const_routes.ROUTE_EXPERIENCE_FILE_DATA}`,
      endpoint: "downloadExampleExperience",
      fullFilename: "3333_ExperienciasAdaptaciones_ejemplo.xlsx",
      preFilename: "3333_ExperienciasAdaptaciones_pre_ejemplo.xlsx",
      termFilename: "3333_ExperienciasAdaptaciones_term_ejemplo.xlsx",
      getState
    });
  };
};

export const startImportDataExperienceClean = () => ({
  type: types.IMPORT_DATA_EXPERIENCE_CLEAN
});

export const startUploadingExperienceDataLocalPaginated = (file, saveCorrectRows, page, size) => {
  return async (dispatch, getState) => {

    const { limit } = getPagination(page, size);

    const state = getState();
    const { totalRows, bagRowProcess } = state.importDataExperience;

    if (totalRows === 0) {
      const formData = new FormData();

      formData.append(`file`, file);
      formData.append("saveCorrectRows", saveCorrectRows);
      formData.append("stage", resolveImportStageFromState(state));

      dispatch(startImportDataExperienceLoading());

      try {
        const resp = await fetchTokenFile(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_EXPERIENCE_FILE_DATA}`,
        `importExperience`,
        formData,
        "POST"
      );

        let body;
        try {
          body = await resp.json();
        } catch (parseErr) {
          body = {
            ok: false,
            code: 'bak-error-api-unavailable',
            msg: t('alerts.validation.bak-error-api-unavailable'),
          };
        }

        if (body) {
          dispatch(startImportDataExperienceFinish());
        }

      debugLogActions(':: importDataExperienceActions, startUploadingExperienceDataLocalPaginated', { 'body': body });

      if (body.ok) {

        let totalRowsExcelFile = 0;
        totalRowsExcelFile = body.bagRowProcess && body.bagRowProcess.length;

        const dataFromExcelFileListPaginated = getPagingData(body.bagRowProcess, page, limit, totalRowsExcelFile);

        const { totalItemsForP, technologysForP, totalPagesForP, currentPageForP } = dataFromExcelFileListPaginated;

        const processInformation = {
          bagListRowsInvalid: body.bagListRowsInvalid,
          bagListRowsSaved: body.bagListRowsSaved,
          bagListRowsValid: body.bagListRowsValid,
          bagRowProcess: body.bagRowProcess,
          totalRows: body.totalRows,
          numberOfRowsValid: body.numberOfRowsValid,
          numberOfRowsSaved: body.numberOfRowsSaved,
          numberOfRowsInvalid: body.numberOfRowsInvalid,
          totalItems: totalItemsForP,
          totalPages: totalPagesForP,
          currentPage: currentPageForP,
          technologysP: technologysForP
        }

        dispatch(startImportDataExperience(processInformation));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.import_file"),
          icon: "success",

          confirmButtonText: t("titles.acept"),
          denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {

          }
        });

      } else {
        /*if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }*/

          // Extraemos el mensaje dinámico del backend o asignamos uno genérico de respaldo
        const backendMessage = body.msg || t("alerts.validation.default_error");
        
        switch (body.code) {
          case "bak-error-001":
            // Error genérico crítico de código
            Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
            break;

          case "bak-error-import-file-001":
            // Formato o plantilla incorrecta (Módulo equivocado) - Muestra el Swal amigable con el msg real del backend
            Swal.fire({
              title: t("titles.error"),
              text: backendMessage, // Imprime: "El archivo no corresponde a la plantilla del módulo de Regulaciones."
              icon: "warning", // Se usa 'warning' porque es un error de usuario/archivo, no un fallo del sistema
              confirmButtonText: t("titles.acept")
            });
            break;

          case "bak-error-import-file-002":
            // No se encontró la pestaña 'datos'
            Swal.fire({
              title: t("titles.error"),
              text: backendMessage, // Imprime: "No se encontró la pestaña llamada 'datos' en el archivo Excel."
              icon: "warning",
              confirmButtonText: t("titles.acept")
            });
            break;

          case "bak-error-import-file-003":
          case "bak-error-import-file-004":
            // Errores estructurales de base de datos o llaves relacionales rotas
            Swal.fire({
              title: t("titles.error"),
              text: `${t("alerts.validation.database_error")} - ${backendMessage}`,
              icon: "error",
              confirmButtonText: t("titles.acept")
            });
            break;

          case "bak-aut-tok-inv-001":
            Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
            dispatch(startLogout());
            break;

          case "bak-aut-tok-inv-002":
            Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
            dispatch(startLogout());
            break;

          case "bak-error-api-unavailable":
            Swal.fire({
              title: t("titles.error"),
              text: backendMessage,
              icon: "error",
              confirmButtonText: t("titles.acept")
            });
            break;

          default:
            // Manejo por si llega un código inesperado del servidor
            Swal.fire(t("titles.error"), backendMessage, "error");
            break;
        }
      }
      } catch (networkErr) {
        dispatch(startImportDataExperienceFinish());
        Swal.fire({
          title: t("titles.error"),
          text: t("alerts.validation.bak-error-api-unavailable"),
          icon: "error",
          confirmButtonText: t("titles.acept"),
        });
        debugLogActions(':: importDataExperienceActions, network error', { error: networkErr?.message });
      }

    } else if (totalRows > 0) {
      const dataFromExcelFileListPaginated = getPagingData(bagRowProcess, page, limit, totalRows);

      const { totalItemsForP, technologysForP, totalPagesForP, currentPageForP } = dataFromExcelFileListPaginated;

      const processInformation = {
        totalItems: totalItemsForP,
        totalPages: totalPagesForP,
        currentPage: currentPageForP,
        technologysP: technologysForP
      }
      dispatch(startImportDataExperienceLocalInPagination(processInformation));

    }
  };
};

const getPagination = (page, size) => {
  const limit = size ? +size : 3;
  const offset = page ? page * limit : 0;
  return { limit, offset };
};

const getPagingData = (data, page, limit, numberOfRows) => {
  const totalItemsForP = numberOfRows;
  const currentPageForP = page ? +page : 0;
  const totalPagesForP = Math.ceil(numberOfRows / limit);

  const startIndex = page * limit;
  const endIndex = ((page + 1) * limit);
  const technologysForP = data.slice(startIndex, endIndex);

  return { totalItemsForP, technologysForP, totalPagesForP, currentPageForP };
};

const startImportDataExperienceLoading = () => ({
  type: types.IMPORT_DATA_EXPERIENCE_LOADING
});

const startImportDataExperienceFinish = () => ({
  type: types.IMPORT_DATA_EXPERIENCE_FINISH
});

const startImportDataExperience = (processInformation) => ({
  type: types.IMPORT_DATA_EXPERIENCE,
  payload: processInformation,
});

const startImportDataExperienceLocalInPagination = (processInformation) => ({
  type: types.IMPORT_DATA_EXPERIENCE_LOCAL_PAGINATION,
  payload: processInformation,
});